import React from 'react';

import cx from 'classnames';
import CSSModule from 'react-css-modules';

import styles from './FormRadio.module.scss';

export const FormRadio = ({
  label,
  name,
  value,
  options = [],
  onChange,
  readOnly,
  disabled,
}) => {
  return (
    <div className="form-radio-group">
      {options.map(opt => (
        <div
          key={opt.value}
          styleName={cx('radio', {
            checked: value === opt.value,
          })}
          className="d-flex align-items-center"
        >
          <input
            type="radio"
            name={name}
            value={opt.value}
            checked={value === opt.value}
            onChange={() => onChange(opt.value)}
            readOnly={readOnly}
            disabled={disabled}
          />
          <label>{opt.label}</label>
        </div>
      ))}
    </div>
  );
};

export default CSSModule(FormRadio, styles, { allowMultiple: true });
